import { fetch } from '@/plugin/axiosNoLogin'
const serverName = '/repair'

export function getOrderPageList(data) {
  return fetch({
    url: serverName + '/api/repair/order/pageList',
    method: 'POST',
    data
  })
}